import React from 'react';

import { LoadingIndicator, LoadingIndicatorProps } from '@motorway/mw-highway-code/alpha';

export const LoadingArrow: React.FC<LoadingIndicatorProps> = (props) => (
  <LoadingIndicator variant="arrow" {...props} />
);
